import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=1fd245f1&scoped=true&lang=pug&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd245f1",
  null
  
)

export default component.exports